import { AlertMessage, Link } from 'app-components'
import ContactUs from '@/app/components/ContactUs/ContactUs'
import { useNavigation } from '@/app/hooks'
import { useAppSelector } from '@/hooks'

export default function PendingPlanAlert() {
  const hasPendingPlan = useAppSelector(
    (state) => state.user.user?.profile?.is_plan_pending,
  )
  const navigation = useNavigation()

  if (!hasPendingPlan) {
    return null
  }

  return (
    <AlertMessage variant="info">
      <div className="flex flex-col gap-2">
        <div className="font-bold">Pending Plan</div>
        <div>
          We are currently finding your plan from your utility bill. Please{' '}
          <span className="font-bold">
            <ContactUs />
          </span>{' '}
          ro re-upload or check the status.
        </div>
        <div className="flex flex-col">
          <div>Tired of waiting?</div>
          <Link
            onClick={() =>
              navigation.push('/connect-utility/plan/manual-select')
            }
          >
            Add Plan Manually
          </Link>
        </div>
      </div>
    </AlertMessage>
  )
}
